import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconTrash';
/** Renders an SVG icon. */
const SvgTrash = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11 5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h6a1 1 0 1 1 0 2h-1.044l-.827 18.182A4 4 0 0 1 21.133 30H10.867a4 4 0 0 1-3.996-3.818L6.044 8H5a1 1 0 0 1 0-2h6zm2 1h6V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1zM8.046 8l.823 18.09A2 2 0 0 0 10.867 28h10.266a2 2 0 0 0 1.998-1.91L23.953 8zM13 12a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V13a1 1 0 0 1 1-1m6 0a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V13a1 1 0 0 1 1-1"
      />
    </svg>
  );
};
SvgTrash.displayName = displayName;
export default SvgTrash;
